import {createPersister} from '@github-ui/react-query-persister'
import type {SendAnalyticsEventFunction} from '@github-ui/use-analytics'
import type {Milestone} from './milestone'
import type {MilestonePickerQueryData} from './api-get-search-milestones'

function isMilestone(obj: unknown): obj is Milestone {
  if (typeof obj !== 'object' || obj === null) return false
  const item = obj as Record<string, unknown>
  return (
    typeof item.id === 'string' &&
    typeof item.title === 'string' &&
    typeof item.closed === 'boolean' &&
    typeof item.progressPercentage === 'number' &&
    typeof item.url === 'string'
  )
}

export function isMilestonePickerQueryData(obj: unknown): obj is MilestonePickerQueryData {
  if (typeof obj !== 'object' || obj === null) return false
  const data = obj as Partial<MilestonePickerQueryData>
  return (
    typeof data.repositoryId === 'string' &&
    typeof data.viewerCanCreateMilestones === 'boolean' &&
    Array.isArray(data.milestones) &&
    data.milestones.every(isMilestone)
  )
}

const MilestonePickerQueryDataValidator = {
  Check: (value: unknown): value is MilestonePickerQueryData => isMilestonePickerQueryData(value),
  Code: () => 'manual-validator',
  *Errors() {
    /* no-op */
  },
}

export function createMilestonePersister(sendAnalyticsEvent: SendAnalyticsEventFunction) {
  return createPersister({
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    validator: MilestonePickerQueryDataValidator as any,
    sendAnalyticsEvent,
    enabled: true,
  })
}
